/*
 * @Author: Youn9er 
 * @Date: 2019-10-14 15:59:08 
 * @Last Modified by: Youn9er
 * @Last Modified time: 2019-10-14 21:20:00
 */
export function add(num1, num2) {
    let c, d, e;
    try {
        c = num1.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = num2.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (multiply(num1, e) + multiply(num2, e)) / e;
}

export function subtract(num1, num2) {
    let c, d, e;
    try {
        c = num1.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = num2.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (multiply(num1, e) - multiply(num2, e)) / e;
}

export function multiply(num1, num2) {
    let c = 0,
    d = num1.toString(),
    e = num2.toString();
    try {
        c += d.split(".")[1].length;
    } catch (f) {}
    try {
        c += e.split(".")[1].length;
    } catch (f) {}
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}

export function divide(num1, num2) {
    let c, d, e = 0,
    f = 0;
    try {
        e = num1.toString().split(".")[1].length;
    } catch (g) {}
    try {
        f = num2.toString().split(".")[1].length;
    } catch (g) {}
    return c = Number(num1.toString().replace(".", "")), d = Number(num2.toString().replace(".", "")), multiply(c / d, Math.pow(10, f - e));
    // _math.format(_math.chain(_math.bignumber(num1)).divide(_math.bignumber(num2)).done())
}


// WEBPACK FOOTER //
// libs/util/math.js